module.exports = __webpack_public_path__ + "assets/normal/images/file_download_guide.f4e96e06.png";